module.exports = {
    baseURL: JSON.parse('"https://partners.stage.trustap.com"'),
    partnersBridgeBackendApiURL: JSON.parse('"https://pay.trustap.com"'),
    keycloakConfig: {
        realm: JSON.parse('"trustap-stage"'),
        // This is the URL of the Keycloak server, in the form `<host>/auth` (e.g.
        // `https://sso.trustap.com/auth`).
        url: JSON.parse('"https://sso.trustap.com/auth"'),
        clientID: JSON.parse('"e7045177-c979-45bc-954e-b1162ff712d6"')
    },
}
